export default __webpack_public_path__ + "static/media/guy_lying_down.3916caae.jpg";